import { PermissionRole } from '@wix/wix-data-schema-types'

export const canBeReadByNonAdmin = ({
  permissions: { read },
}: {
  permissions: { read: PermissionRole }
}) => read !== PermissionRole.admin
